import { NgModule } from "@angular/core";

import { ClickOutsideModule } from "ng-click-outside";
import { RouterModule } from "@angular/router";
import { CardModule } from "primeng/card";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { PasswordModule } from "primeng/password";
import { CaptchaModule } from "primeng/captcha";
import { RecaptchaService } from "../../../services/security/recaptcha-service";
import {
  CheckboxModule,
  ConfirmDialogModule,
  DropdownModule,
  RadioButtonModule,
} from "primeng/primeng";
import { TwoFactorSendCodeComponent } from "./components/twofactor/send-code/send-code.component";
import { TwoFactorVerifyCodeComponent } from "./components/twofactor/verify-code/verify-code.component";
import {
  ShowHidePasswordModule,
  ShowHideService,
} from "ngx-show-hide-password";
import { BrowserModule } from "@angular/platform-browser";
import { NewPasswordComponent } from "./components/newpassword/newpassword.component";
import { SendTokenResetPasswordComponent } from "./components/sendtokennewpassword/send-token-possword.component";
import { ConfirmAccountComponent } from "./components/confirm-account/confirm-account.component";
import { AppCommonModule } from "@modules/common/app-common.module";
import { LoginComponent } from "./components/login/login.component";
import { CodeInputModule } from 'angular-code-input';
import { CircleTimerModule } from '@flxng/circle-timer';
import { ConfirmChangeEmailComponent } from "./components/confirm-changeEmail/confirm-changeEmail.component";

@NgModule({
  declarations: [ 
    LoginComponent,
    TwoFactorSendCodeComponent,
    TwoFactorVerifyCodeComponent,
    NewPasswordComponent,
    SendTokenResetPasswordComponent,
    ConfirmAccountComponent,
    ConfirmChangeEmailComponent
  ],
  imports: [
    BrowserModule,
    CommonModule,
    RouterModule,
    ClickOutsideModule,
    FormsModule,
    ReactiveFormsModule,
    CardModule,
    PasswordModule,
    CaptchaModule,
    CheckboxModule,
    DropdownModule,
    RadioButtonModule,
    ShowHidePasswordModule,
    ConfirmDialogModule,
    AppCommonModule,
    CodeInputModule,
    CircleTimerModule
  ],
  providers: [RecaptchaService, ShowHideService],
  exports: [ 
    TwoFactorSendCodeComponent,
    TwoFactorVerifyCodeComponent,
  ],
  entryComponents: [
    LoginComponent,
    TwoFactorSendCodeComponent,
    TwoFactorVerifyCodeComponent,
  ],
})
export class AuthAccountModule {}
